import { AddIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Center,
  Container,
  Divider,
  Flex,
  Heading,
  Image,
  VStack,
} from "@chakra-ui/react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/Auth";
import { getPartnerReadingOrders } from "../../../services/partnerApi";
import Spinner from "../../../shared/components/Spinner";
import PartnerReadingCard from "../components/PartnerReadingCard";
import PartnerStats from "../components/PartnerStats";

const PartnerReadingOrderList = () => {
  const navigate = useNavigate();
  const { authData } = useAuth();
  const { data, isSuccess, isLoading, isError } = useQuery(
    ["readingOrders"],
    () => getPartnerReadingOrders()
  );

  const onEditInfo = (readingOrderId) => {
    navigate(`/partnership/reading-orders/${readingOrderId}/edit`);
  };

  const onEditOrder = (readingOrderId) => {
    navigate(`/partnership/reading-orders/${readingOrderId}/comics`);
  };

  return (
    <VStack>
      <Container maxW="container.lg">
        <Box minH="100vh" py="12" px={{ base: "4", lg: "8" }}>
          <Box maxW="xxl" mx="auto">
            <Box>
              <Flex alignItems="center">
                {authData.partnerThumbnail && (
                  <Image
                    src={authData.partnerThumbnail}
                    alt="partner logo"
                    w="56px"
                    h="56px"
                    borderRadius="full"
                    mr="3"
                  />
                )}
                <Heading as="h2" my="6">
                  {authData && authData.partnerName
                    ? authData.partnerName
                    : "My Reading orders"}
                </Heading>
              </Flex>
              <PartnerStats />
              <Divider my="6" />
              <Center mb="6">
                <Flex alignItems="center">
                  <Heading as="h2" size="md" mb="4">
                    Reading orders
                  </Heading>
                </Flex>
                <Button
                  onClick={() => navigate("/partnership/reading-orders/new")}
                  ml="auto"
                  leftIcon={<AddIcon />}
                >
                  Add new reading order
                </Button>
              </Center>
              {isError && <p>Error.</p>}
              {isLoading && <Spinner />}
              {isSuccess && !isLoading && (
                <Box>
                  {data.data.map((order, index) => (
                    <PartnerReadingCard
                      readingOrder={order}
                      onClickEdit={onEditInfo}
                      onClickEditOrder={onEditOrder}
                      key={order.id}
                      index={index}
                    />
                  ))}
                  {data.data.length === 0 && (
                    <Center p="6">
                      To get started, add a new reading order.
                    </Center>
                  )}
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Container>
    </VStack>
  );
};

export default PartnerReadingOrderList;
